import {LIST_CATEGORY , ADD_CATEGORY ,UPDATE_CATEGORY ,DELETE_CATEGORY} from './categoryTypes'
import {URL_LIST_CATEGORY ,URL_ADD_CATEGORY ,URL_UPDATE_CATEGORY , URL_DELETE_CATEGORY} from './categoryUrls'
import { ResponseModel, STATUS_OK } from '../../models/network/response_model'
import axios from "../../axios";

export default {
  [LIST_CATEGORY]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_LIST_CATEGORY}${param}`)
        .then((response) => {
          console.log()
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(LIST_CATEGORY, data);
              resolve(data);
            } else {
              commit(LIST_CATEGORY, {items: [], _links: {}, _meta: {}});
              resolve({items: [], _links: {}, _meta: {}});
            }
          } else {
            commit(LIST_CATEGORY, {items: [], _links: {}, _meta: {}});
            resolve({items: [], _links: {}, _meta: {}});
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [ADD_CATEGORY]({dispatch }, item) {
    let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      return new Promise((resolve, reject) => {
        axios.post(`${URL_ADD_CATEGORY}`, data)
          .then((response) => {
            let responseModel = new ResponseModel(response);
            if(responseModel.status == STATUS_OK) {
              let resultModel = responseModel.result;
              if(resultModel.status == STATUS_OK) {
                let data = resultModel.data;
                delete item.name
                dispatch(LIST_CATEGORY, item);
                resolve(data);
              } else {
                if(resultModel.message && resultModel.message.name) {
                  reject(resultModel.message.name[0]);
                } else {
                  let data = resultModel.data;
                  delete item.name
                  dispatch(LIST_CATEGORY);
                  resolve(data);
                }
              }
            } else {
              reject(responseModel.message);
            }
          })
          .catch((error) => { reject(error) })
      })
    },

    [UPDATE_CATEGORY]({dispatch}, item) {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      let param = new URLSearchParams({id:item.id}).toString();
      return new Promise((resolve, reject) => {
        axios.post(`${URL_UPDATE_CATEGORY}${param}`, data)
          .then((response) => {
            let responseModel = new ResponseModel(response);
            if(responseModel.status == STATUS_OK) {
              let resultModel = responseModel.result;
              if(resultModel.status == STATUS_OK) {
                let data = resultModel.data;
                delete item.name
                dispatch(LIST_CATEGORY, item);
                resolve(data);
              } else {
                if(resultModel.message && resultModel.message.name) {
                  reject(resultModel.message.name[0]);
                } else {
                  let data = resultModel.data;
                  delete item.name
                  dispatch(LIST_CATEGORY);
                  resolve(data);
                }
              }
            } else {
              reject(responseModel.message);
            }
          })
          .catch((error) => { reject(error) })
      })
    },

    [DELETE_CATEGORY]({dispatch}, item) {
      let param = new URLSearchParams(item).toString();
      return new Promise((resolve, reject) => {
        axios.get(`${URL_DELETE_CATEGORY}${param}`)
          .then((response) => {
            let responseModel = new ResponseModel(response);
            if(responseModel.status == STATUS_OK) {
              let resultModel = responseModel.result;
              if(resultModel.status == STATUS_OK) {
                let data = resultModel.data;
                delete item.name
                dispatch(LIST_CATEGORY, item);
                resolve(data);
              } else {
                reject(resultModel.message);
              }
            } else {
              reject(responseModel.message);
            }
          })
          .catch((error) => { reject(error) })
      })
    },
}

